import React from 'react';
import { connect } from 'react-redux';
import NoDataAndLoading from 'components/NoDataAndLoading/NoDataAndLoading';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { listFeedbackRequest } from 'actions/customers/feedback';
import { formValueSelector } from 'redux-form';
import moment from 'moment';
import styles from './style.feedback.css';

class FeedbackTable extends React.Component {
  render() {
    const { feedbacks } = this.props.data.customers.feedback;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;

    return (
      <div
        className={`col-md-12 ${styles['table-feedback']}`}
        id="customer-feedback"
      >
        {feedbacks.length > 0 && (
          <div
            className="col-sm-12 trans-1 box-customers no-padding"
            id="mk-col-left"
          >
            <table className="table header-table mk-table-fixed table-truncate">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Comment</th>
                </tr>
              </thead>
            </table>
            <div className={`${styles['box-scroll']} feedback-box-scroll`}>
              <InfiniteScroll
                pageStart={1}
                loadMore={this._onReachBottom}
                hasMore={this._hasMore}
                useWindow={false}
                threshold={10}
                initialLoad={false}
              >
                <table className="table mk-table-fixed table-truncate">
                  <tbody>
                    {feedbacks.map((feedback, idx) => {
                      return (
                        <tr
                          key={idx}
                          onClick={() => this._onClickRow(feedback)}
                          className={styles['feedback-row']}
                        >
                          <td>{feedback.feedback_date}</td>
                          {feedback.feedback_from === 'sms' && (
                            <td>
                              {feedback.customer_name ||
                                feedback.customer_phone ||
                                feedback.customer_email}
                            </td>
                          )}
                          {feedback.feedback_from !== 'sms' && (
                            <td>
                              {feedback.customer_name ||
                                feedback.customer_email ||
                                feedback.customer_phone}
                            </td>
                          )}
                          <td>
                            {feedback.mode === 'happy' ? (
                              <i className="fa fa-smile-o" />
                            ) : (
                              <i className="fa fa-frown-o" />
                            )}
                            <span className="title type">
                              {feedback.feedback_type}
                            </span>
                            <span className="comment">
                              {`"${feedback.comment}"`}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        )}
        {feedbacks.length === 0 && (
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay
            title="No Data To Display"
            description=""
            linkLabel="View and Respond to Customer Feedback"
            linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900001105463"
          />
        )}
      </div>
    );
  }

  _onClickRow = feedback => {
    this.props.onClickRow(feedback);
  };

  _onReachBottom = () => {
    const { feedbacks, currentPage } = this.props.data.customers.feedback;
    const { startDate, endDate } = this.props.search.date;
    const startDateFormatted = moment(startDate).format('D/M/YYYY');
    const endDateFormatted = moment(endDate).format('D/M/YYYY');
    this.props.dispatch(
      listFeedbackRequest(
        {
          start: startDateFormatted,
          end: endDateFormatted,
          page: currentPage + 1,
        },
        feedbacks
      )
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props.data.customers.feedback;
    return currentPage < totalPage;
  };
}

FeedbackTable.propTypes = {
  onClickRow: PropTypes.func,
};

const selector = formValueSelector('search');

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback,
      },
      loadingSpinner: state.loadingSpinner,
    },
    search: {
      date: selector(state, 'date'),
    },
  };
}

export default connect(mapStateToProps)(FeedbackTable);
